import { render, staticRenderFns } from "./GenericSwitchInput.vue?vue&type=template&id=6e40c170&scoped=true"
import script from "./GenericSwitchInput.vue?vue&type=script&lang=ts"
export * from "./GenericSwitchInput.vue?vue&type=script&lang=ts"
import style0 from "./GenericSwitchInput.vue?vue&type=style&index=0&id=6e40c170&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e40c170",
  null
  
)

export default component.exports